import axios from "axios";
axios.defaults.withCredentials = true;

export let DOMAIN = "";
export let BASE_URL = "";
export let LMS_BASE_URL = "";
export let SCHOOL_INFO = {};

const hostname = window.location.hostname;

if (hostname.includes("localhost")) {
    DOMAIN = "localhost";
    BASE_URL = "https://localhost/Capistone/backend";
    LMS_BASE_URL = "https://localhost/LMS/backend";
} else {
    DOMAIN = hostname.split(".").slice(-2).join(".");
    BASE_URL = `https://${hostname}/backend`;
    LMS_BASE_URL = `https://lms.${DOMAIN}/backend`;
}

axios.get(`${BASE_URL}/schoolEnv/getByKey.php`, {
    params: { key: DOMAIN }
}).then(res => {
    SCHOOL_INFO = res.data.data;
}).catch(err => {
    console.error(err.message);
})
